module.exports = __webpack_public_path__ + "img/avicola.501a6a13.png";